import { DeviceTypeEnum, reduce } from '@rmc/webcx-web-libs';
import { getNativeRcxCookie } from '../../lib/Cookies/RcxCookie';
import { getNativeRzCookie } from '../../lib/Cookies/RzCookie';
import { getLocation } from '../../lib/REST/utils';
import { WebBlocksApiBlockT, ReplacementType } from '../../lib/REST/types';

export function getCreatePortalKey({
	contentId = '',
	campaignId = '',
	replacementId = '',
	selector = '',
}: {
	contentId: string;
	campaignId: string;
	replacementId?: string;
	selector?: string | null;
}) {
	return `${contentId}-${campaignId}-${replacementId}-${selector}`;
}

const MOBILE_SCREEN_MAX_WIDTH = 768;

function isScreenMobile() {
	return window.innerWidth <= MOBILE_SCREEN_MAX_WIDTH;
}

export function getDevice(): string {
	const isMobile = isScreenMobile();
	return isMobile ? DeviceTypeEnum.MOBILE : DeviceTypeEnum.DESKTOP;
}

export function getMainAppInfo() {
	return {
		sessionId: getNativeRcxCookie(),
		isMobile: isScreenMobile(),
		location: getLocation(),
		userId: getNativeRzCookie(),
		device: getDevice(),
	};
}

function filterReplacements(
	replacements: ReplacementType[] | null | undefined = []
): ReplacementType[] {
	if (
		!replacements ||
		replacements.length === 0 ||
		replacements === null ||
		replacements === undefined ||
		!Array.isArray(replacements)
	) {
		return [];
	}

	const callbackFn = (
		acc: {
			replacements: ReplacementType[];
			replacementSelectorSet: Set<string>;
		},
		replacement: ReplacementType
	) => {
		const { selector } = replacement;

		if (acc.replacementSelectorSet.has(selector)) {
			return { ...acc };
		}

		acc.replacementSelectorSet.add(selector);
		acc.replacements.push(replacement);

		return {
			...acc,
			replacements: [...acc.replacements],
			replacementSelectorSet: acc.replacementSelectorSet,
		};
	};
	const initailValue = {
		replacements: [],
		replacementSelectorSet: new Set<string>(),
	};

	const result = reduce(replacements, callbackFn, initailValue);

	return result.replacements;
}

export function filterDuplicates({
	blocks = [],
}: {
	blocks: WebBlocksApiBlockT[] | undefined;
}) {
	if (blocks === undefined) {
		return [];
	}

	const callbackFn = (
		acc: {
			blocks: WebBlocksApiBlockT[];
			selectorSet: Set<string>;
		},
		block: WebBlocksApiBlockT
	) => {
		block.replacements = filterReplacements(block.replacements);
		const { replacements } = block;
		const doesSelectorExist = !!replacements.length;

		if (!doesSelectorExist) {
			return {
				...acc,
				blocks: [...acc.blocks, block],
				selectorSet: acc.selectorSet,
			};
		}

		for (let j = 0; j < replacements.length; j += 1) {
			const replacement = replacements[j];
			const { selector } = replacement;

			if (acc.selectorSet.has(selector)) {
				break;
			}

			if (!acc.selectorSet.has(selector)) {
				acc.selectorSet.add(selector);
			}

			if (j === replacements.length - 1) {
				acc.blocks.push(block);
			}
		}

		return {
			...acc,
		};
	};

	const initailValue = { blocks: [], selectorSet: new Set<string>() };

	const result = reduce(blocks, callbackFn, initailValue);

	return result.blocks;
}
